import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=loading, null=not auth, obj=auth
  const [titolareSettore, setTitolareSettore] = useState(() => localStorage.getItem("efp-settore") || "sportivo");

  useEffect(() => {
    const t = localStorage.getItem("efp-token");
    if (!t) { setUser(null); return; }
    api.me().then(setUser).catch(() => { localStorage.removeItem("efp-token"); setUser(null); });
  }, []);

  const login = useCallback(async (email, password) => {
    const res = await api.login(email, password);
    localStorage.setItem("efp-token", res.access_token);
    setUser(res.user);
    return res.user;
  }, []);

  const register = useCallback(async (data) => {
    const res = await api.register(data);
    localStorage.setItem("efp-token", res.access_token);
    setUser(res.user);
    return res.user;
  }, []);

  const logout = useCallback(() => {
    api.logout().catch(() => {});
    localStorage.removeItem("efp-token");
    setUser(null);
  }, []);

  const applyAuth = useCallback((res) => {
    localStorage.setItem("efp-token", res.access_token);
    setUser(res.user);
    return res.user;
  }, []);

  const isTitolare = user && user.role === "titolare";
  const activeSettore = isTitolare ? titolareSettore : (user?.settore || "sportivo");
  const setActiveSettore = useCallback((s) => {
    const v = s || "sportivo";
    setTitolareSettore(v);
    localStorage.setItem("efp-settore", v);
  }, []);

  return (
    <AuthContext.Provider value={{ user, isTitolare, activeSettore, setActiveSettore, login, register, logout, applyAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
